import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { LocationSetTypesActions } from './location-set-types.actions';
import { MenuBaseActions } from '../base/menu-base.actions';
import { AsyncActions } from './location-set-types.actions';
import {LocationSetType} from '@emm/core/models/location-set-type.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {sortByWeight, withLoadables} from '@emm/core/util/ngrx.util';

export const locationSetTypesFeatureKey = 'locationSetTypes';

export interface LocationSetTypesState extends EntityState<LocationSetType>, AsyncActionState {
    selectedTag: string | null;
}

export const adapter: EntityAdapter<LocationSetType> = createEntityAdapter<LocationSetType>({
    selectId: (item: LocationSetType) => item.tag,
    sortComparer: sortByWeight
});

export const initialState: LocationSetTypesState = adapter.getInitialState({
    selectedTag: null,
    ...asyncActionState.initial
});

export const { loadActions, successActions, errorActions } = AsyncActions;

export const locationSetTypesReducer = withLoadables<LocationSetTypesState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(MenuBaseActions.init, state => ({
        ...initialState
    })),

    on(LocationSetTypesActions.load, (state: LocationSetTypesState) => ({
        ...state,
        selectedTag: null
    })),

    on(LocationSetTypesActions.loadSuccess, (state: LocationSetTypesState, { locationSetTypes }) =>
        adapter.setAll(locationSetTypes, state)
    ),

    on(LocationSetTypesActions.select, (state: LocationSetTypesState, { tag }) => ({
        ...state,
        selectedTag: tag,
    }))

);
